import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilidadesService } from './utilidades.service';
import { NavController } from '@ionic/angular';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ConexionService {
  SubirFotoGaleria(arg0: any) {
    throw new Error('Method not implemented.');
  }
    private APILink = 'http://192.168.0.127:5000';
  // private APILink = 'https://leonardo-da-vinci.edu.do:6515/api';
  private APILinkPWA = environment.ApiLink;
  
  // private APILinkPWA = "http://199.168.2.30:5000"
  // private APILinkPWA = "https://leonardo-da-vinci.edu.do:5500"
  // private APILinkPWA = "http://127.0.0.1:5000"

  private TokenApp =
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJBcHAiOiJQV0EiLCJGZWNoYSI6IjIwMjItMDEtMzEgMTA6NDE6MTYuNjk5NjE3In0.FLMyCjnL4GAZjMOpN0NlClj0ZUWcnZb6i2FASGkjhc8';
  constructor(
    private http: HttpClient,
    private utilidades: UtilidadesService,
    private nav: NavController
  ) {
    let host = location.hostname;

    if (host == 'localhost' || host == '192.168.0.78' || host == '199.168.2.30') {
      this.APILinkPWA = 'http://192.168.0.127:5000';
    } else if (host == 'app.leonardo-da-vinci.edu.do') {
      this.APILinkPWA = 'https://app-api.leonardo-da-vinci.edu.do';
    } else {
      this.APILinkPWA = 'https://testapp-api.leonardo-da-vinci.edu.do';
    }

  }

  test_connection(): Observable<any> {
    return this.http.get(this.APILinkPWA + '/test_connection_dvinci_api_colleger', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  CorreoContacto(data): Observable<any> {
    return this.http.post(this.APILinkPWA + '/CorreoContacto', data, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  Registro(data): Observable<any> {
    return this.http.post(this.APILinkPWA + '/Registro', data, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  AgregarFamilia(codigo, user): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/AgregarFamilia',
      { IdUsuario: user, CodigoRegistro: codigo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );
  }

  RecuperarPassword(email): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/RecuperarPassword',
      { Email: email },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );
  }

  EnviarCorreoCambioCorreo(password, iduser, email): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/EnviarCorreoCambioCorreo',
      {
        Email: email,
        Password: password,
        IdUser: iduser,
      },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );
  }

  CambiarPassword(token, password): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/CambiarPassword',
      { Token: token, Password: password },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );
  }

  ActualizarUsuario(user): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/ActualizarUsuario',
      { User: user },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );
  }

  getFamilias(filtro): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFamilias?Filtro=' + filtro,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFamilia(codigo): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFamilia?CodigoFamilia=' + codigo,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarEstadoFamilias(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarEstadoFamilias',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  GenerarCodigoFamilias(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/GenerarCodigoFamilias',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getUsuarios(idtipo: string): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getUsuarios?IdTipo=' + idtipo,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getUsuariosEnMisFamilias(id_usuario: string): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getUsuariosEnMisFamilias?IdUsuario=' + id_usuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getUsuario(id: string): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getUsuario?Id=' + id, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getTiposUsuarios(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getTiposUsuarios', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  CambiarRolUsuario(IdUser, Roles, SolicitudPago = false): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarRolUsuario',
      { Roles, IdUser, SolicitudPago },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarEstadoUsuario(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarEstadoUsuario',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  ReenviarCorreoActivacion(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ReenviarCorreoActivacion',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getUsuariosFamilia(codigo_familia): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getUsuariosFamilia?CodigoFamilia=' + codigo_familia,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getHijosFamilia(codigo_familia): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getHijosFamilia?CodigoFamilia=' + codigo_familia,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFamiliasUsuario(userid): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFamiliasUsuario?UserID=' + userid,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  DesvincularUsuarioFamilia(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/DesvincularUsuarioFamilia',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  DesvincularFamiliasUsuario(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/DesvincularFamiliasUsuario',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  Login(email: string, password: string): Observable<any> {
    let data = { Email: email, Password: password };

    return this.http.post(this.APILinkPWA + '/Login', data, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  LoginToken(email: string, token: string): Observable<any> {
    let data = { Email: email, Token: token };

    return this.http.post(this.APILinkPWA + '/LoginToken', data, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  ActivarUsuario(tokenf: string): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/ActivarUsuario',
      { TokenF: tokenf },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );
  }

  NotificacionesPorCorreo(id_user: string, estado, tipo): Observable<any> {
    return this.http.post(
      this.APILinkPWA + '/NotificacionesPorCorreo',
      { Usuario: id_user, Estado: estado, Tipo: tipo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );
  }

  getRoles(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getRoles', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  GuardarRol(rol: string): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/GuardarRol',
      { Rol: rol },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EditarRol(rol: string, id): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EditarRol',
      { Rol: rol, Id: id },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarRol(id): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarRol',
      { Id: id },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getPrivilegios(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getPrivilegios', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  ActualizarPrivilegios(
    idtipo: string,
    privilegios: Array<any>
  ): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ActualizarPrivilegios',
      { IdTipo: idtipo, Privilegios: privilegios },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirFotoCalendario(archivo: File, titulo: string): Observable<any> {
    let form = new FormData();
    form.append('Titulo', titulo);
    form.append('Archivo', archivo);

    let respuesta = this.http.post(
      this.APILinkPWA + '/SubirFotoCalendario',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EditarFotoCalendario(archivo: File, id): Observable<any> {
    let form = new FormData();
    form.append('Id', id);
    form.append('Archivo', archivo);

    let respuesta = this.http.post(
      this.APILinkPWA + '/EditarFotoCalendario',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EditarCalendario(titulo: string, id): Observable<any> {
    let form = new FormData();
    form.append('Titulo', titulo);
    form.append('Id', id);

    let respuesta = this.http.post(
      this.APILinkPWA + '/EditarCalendario',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }
  

  getFotosCalendario(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getFotosCalendario', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  OrdenarCalendario(fotos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/OrdenarCalendario',
      { Fotos: fotos },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarFotoCalendario(foto): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarFotoCalendario',
      { Foto: foto },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadCalendario(id, visible): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadCalendario',
      { Id: id, Visible: visible },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getComunicados(campo, tipo_orden, secciones = 'todas', userId = ''): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getComunicados?Campo=' +
      campo +
      '&TipoOrdenamiento=' +
      tipo_orden +
      '&Secciones=' +
      secciones +
      '&UserId=' +
      userId,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  MarcarComoLeidos(campo, tipo_orden, secciones = 'todas', userId = ''): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/MarcarComoLeidos?Campo=' +
      campo +
      '&TipoOrdenamiento=' +
      tipo_orden +
      '&Secciones=' +
      secciones +
      '&UserId=' +
      userId,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getComunicado(id, secciones = 'todas', userId = ''): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getComunicado?IdComunicado=' +
      id +
      '&Secciones=' +
      secciones +
      '&UserId=' +
      userId,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getComunicadosRecientes(secciones, user): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getComunicadosRecientes?Secciones=' +
      secciones +
      '&User=' +
      user,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getActividadesRecientes(): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getActividadesRecientes',
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCursosDestinos(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getCursosDestinos', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getCursosDestinosAnio(IdAnio): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getCursosDestinosAnio?IdAnio='+IdAnio, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getNotificaciones(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getNotificaciones', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }


  getIndicadoresLogroUsuarios(): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogroUsuarios",
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getReportesProgresoUsuarios(): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getReportesProgresoUsuarios",
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getReportesProgresoUsuarioSecciones(id_usuario, id_anio): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getReportesProgresoUsuarioSecciones?IdUsuario=" + id_usuario + "&IdAnio="+id_anio,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getIndicadoresLogroUsuarioAsignaturas(id, id_anio): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogroUsuarioAsignaturas?IdUsuario=" + id+"&IdAnio="+id_anio,

      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getIndicadoresLogroSeccionAsignaturas(id_usuario, id_anio, id_seccion): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogroSeccionAsignaturas?IdUsuario=" + id_usuario + "&IdAnio=" + id_anio + "&IdSeccion=" + id_seccion,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }


  getAsignaturasCategoriasIndicadores(id_seccion, id_usuario): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getAsignaturasCategoriasIndicadores?IdSeccion=" + id_seccion + "&IdUsuario=" + id_usuario,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getReporteIndicadoresEstudiantePorAsignatura(id_estudiantes, idanio): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getReporteIndicadoresEstudiantePorAsignatura?IdEstudiantes=" + id_estudiantes + "&IdAnio=" + idanio,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getIndicadoresLogroSeccionEstudiantes(id_usuario, id_anio, id_seccion): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogroSeccionEstudiantes?IdUsuario=" + id_usuario + "&IdAnio=" + id_anio + "&IdSeccion=" + id_seccion,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getReporteIndicadoresEstudiantePorEstudiantes(id_estudiantes, id_anio, id_asignaturas, id_areas, idtindicadores, filtro): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getReporteIndicadoresEstudiantePorEstudiantes?IdEstudiantes=" + id_estudiantes + "&IdAnio=" + id_anio + "&IdAsignaturas=" + id_asignaturas + "&IdAreas=" + id_areas + "&IdTIndicadores=" + idtindicadores + "&Filtro=" + filtro,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getItemReferenciaNotificaciones(ruta): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getItemReferenciaNotificaciones?Ruta=' + ruta,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getComunicadosCategorias(): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getComunicadosCategorias',
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  guardarIndicadoresLogroUsuarioAsignaturas(datos): Observable<any> {

    let respuesta = this.http.post(this.APILinkPWA + "/guardarIndicadoresLogroUsuarioAsignaturas", { Datos: datos },
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  GuardarCategoria(Nombre): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/GuardarCategoria',
      { Nombre },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  ActualizarCategoria(Nombre, Id): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ActualizarCategoria',
      { Nombre, Id },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarCategoria(Id): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarCategoria',
      { Id },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  GuardarComunicado(Comunicado, pdf: File): Observable<any> {
    let f: string = String(Comunicado.Fecha);

    let fe = f.substr(0, 10);
    let ti = f.substr(11, fe.length - 2);

    let fecha = fe + ' ' + ti;

    Comunicado.Fecha = fecha;

    let form = new FormData();

    for (let i in Comunicado) {
      form.append(i, Comunicado[i]);
    }

    form.append('PDF', pdf);

    let respuesta = this.http.post(
      this.APILinkPWA + '/GuardarComunicado',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  ActualizarComunicado(Comunicado, Pdf: File): Observable<any> {
    let form = new FormData();
    if (Comunicado.Fecha.indexOf('T') > -1) {
      let f: string = String(Comunicado.Fecha);

      let fe = f.substr(0, 10);
      let ti = f.substr(11, fe.length - 2);

      let fecha = fe + ' ' + ti;

      Comunicado.Fecha = fecha;
    }

    for (let i in Comunicado) {
      form.append(i, Comunicado[i]);
    }

    if (Pdf) {
      form.append('Pdf', Pdf);
    }

    let respuesta = this.http.post(
      this.APILinkPWA + '/ActualizarComunicado',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarComunicado(Comunicado): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarComunicado',
      { Comunicado },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirFotoComunicado(idcomunicado, foto: File): Observable<any> {
    let form = new FormData();
    form.append('IdComunicado', idcomunicado);
    form.append('Foto', foto);

    let respuesta = this.http.post(
      this.APILinkPWA + '/SubirFotoComunicado',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  AgregarEnlaceComunicado(Enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/AgregarEnlaceComunicado',
      { Enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EditarEnlaceComunicado(Enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EditarEnlaceComunicado',
      { Enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarFotoComunicado(Foto): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarFotoComunicado',
      { Foto },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarEnlaceComunicado(Enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarEnlaceComunicado',
      { Enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EstablecerDestinosComunicados(Destinos, Comunicado): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EstablecerDestinosComunicados',
      { Destinos: Destinos, Comunicado: Comunicado },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCalendario(user): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getCalendario?User=' + user,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getHorarios(Adm): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getHorarios?Adm=' + Adm, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getHorario(seccion, iduser): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getHorario?getHorario=' +
      seccion +
      '&IdUsuario=' +
      iduser,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getHorariosProfesores(Adm): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getHorariosProfesores?Adm=' + Adm,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirFotoHorario(archivo: File, id_seccion): Observable<any> {
    let form = new FormData();
    form.append('Archivo', archivo);
    form.append('IdSeccion', id_seccion);

    let respuesta = this.http.post(
      this.APILinkPWA + '/SubirFotoHorario',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirFotoHorarioProfesor(archivo: File, IdUsuario): Observable<any> {
    let form = new FormData();
    form.append('Archivo', archivo);
    form.append('IdUsuario', IdUsuario);

    let respuesta = this.http.post(
      this.APILinkPWA + '/SubirFotoHorarioProfesor',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarFotoHorario(idfoto): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarFotoHorario',
      { Foto: idfoto },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarFotoHorarioProfesor(idfoto): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarFotoHorarioProfesor',
      { Foto: idfoto },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadHorario(idseccion, visible): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadHorario',
      {
        IdSeccion: idseccion,
        Visible: visible,
      },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadHorarioProfesor(idusuario, visible): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadHorarioProfesor',
      {
        IdUsuario: idusuario,
        Visible: visible,
      },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getActividades(Adm): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getActividades?Adm=' + Adm,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getActividad(Adm, id, idUsuario = '0'): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getActividad?Adm=' +
      Adm +
      '&IdActividad=' +
      id +
      '&IdUsuario=' +
      idUsuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  GuardarActividad(Actividad): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/GuardarActividad',
      { Actividad },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EditarActividad(Actividad): Observable<any> {
    // alert(JSON.stringify(Actividad))
    let respuesta = this.http.post(
      this.APILinkPWA + '/EditarActividad',
      { Actividad },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarActividad(Actividad): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarActividad',
      { Actividad },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirMultimediaActividad(archivo: File, idactividad, tipo): Observable<any> {
    let form = new FormData();
    form.append('Archivo', archivo);
    form.append('IdActividad', idactividad);
    form.append('Tipo', tipo);

    let respuesta = this.http.post(
      this.APILinkPWA + '/SubirMultimediaActividad',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  OrdenarMediaActividad(media): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/OrdenarMediaActividad',
      { Media: media },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarMultimediaActividad(media): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarMultimediaActividad',
      { Media: media },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadMultimediaActividad(media): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadMultimediaActividad',
      { Media: media },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadSeleccionadosMultimediaActividad(ids_visibilidad): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadSeleccionadosMultimediaActividad',
      { ids_visibilidad },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarPortadaActividad(media): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarPortadaActividad',
      { Media: media },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  GuardarEnlaceActividad(enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/GuardarEnlaceActividad',
      { Enlace: enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarEnlaceActividad(enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarEnlaceActividad',
      { Enlace: enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadEnlaceActividad(enlace): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadEnlaceActividad',
      { Enlace: enlace },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getAniosCalificaciones(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getAniosCalificaciones', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getReportesProgresoUsuarioSeccionesEstudiantes(id_usuario, id_anio): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getReportesProgresoUsuarioSeccionesEstudiantes?IdAnio=' + id_anio + "&IdUsuario=" + id_usuario, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getReportesProgresoInformacion(id_inscripcion, periodo): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getReportesProgresoInformacion?IdInscripcion=' + id_inscripcion + "&Periodo=" + periodo, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  EliminarReporteProgresoEstudiante(id_reporte): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/EliminarReporteProgresoEstudiante', { IdReporte: id_reporte }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  GuardarReportesProgresoEstudiante(info, id_usuario): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/GuardarReportesProgresoEstudiante', { Datos: info, IdUsuario: id_usuario }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  guardarIndicadorLogro(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/guardarIndicadorLogro', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  guardarIndicadorLogroCategoria(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/guardarIndicadorLogroCategoria', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  editarIndicadorLogroCategoria(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/editarIndicadorLogroCategoria', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  eliminarIndicadorLogroCategoria(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/eliminarIndicadorLogroCategoria', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  editarIndicadorLogro(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/editarIndicadorLogro', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  eliminarIndicadorLogro(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/eliminarIndicadorLogro', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  ImportarIndicadoresCategoriasOtroAnio(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + '/ImportarIndicadoresCategoriasOtroAnio', { Datos: datos }, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getDatosCalificaciones(idanio): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getDatosCalificaciones?IdAnio=' + idanio,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  CambiarVisibilidadDatosCalificaciones(id, tipo, valor): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/CambiarVisibilidadDatosCalificaciones',
      { Id: id, Tipo: tipo, Valor: valor },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  SubirFotoPerfil(archivo: File, quien: string, id: string): Observable<any> {
    let form = new FormData();
    form.append('Quien', quien);
    form.append('Id', id);
    form.append('Archivo', archivo);

    let respuesta = this.http.post(this.APILinkPWA + '/SubirFotoPerfil', form, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  EliminarFotoPerfil(quien: string, id: string): Observable<any> {
    let form = new FormData();
    form.append('Quien', quien);
    form.append('Id', id);
    form.append('Info', 'Eliminar');

    let respuesta = this.http.post(this.APILinkPWA + '/SubirFotoPerfil', form, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  Favorito(usuario, idelemento, tipo_elemento, titulo): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/Favorito',
      {
        Favorito: {
          IdUsuario: usuario,
          IdElemento: idelemento,
          TipoElemento: tipo_elemento,
          Titulo: titulo,
        },
      },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EnviarNotificacion(
    titulo,
    mensaje,
    destinos,
    ruta,
    Foto,
    Vias
  ): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EnviarNotificacion',
      {
        Titulo: titulo,
        Mensaje: mensaje,
        Destinos: destinos,
        Ruta: ruta,
        Foto,
        Vias,
      },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  AsociarDispositivoAUsuario(IdUsuario, Sub_Info): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/AsociarDispositivoAUsuario',
      { IdUsuario, Sub_Info },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  DesAsociarDispositivoAUsuario(IdNotificacion): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/DesAsociarDispositivoAUsuario',
      { IdNotificacion },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFile(idarchivo, nombre): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFile?IdArchivo=' + idarchivo + '&Nombre=' + nombre,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
        responseType: 'blob',
      }
    );

    return respuesta;
  }

  deleteFileLocal(nombre): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/deleteFileLocal?Nombre=' + nombre,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  ValidarQR(qr): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ValidarQR',
      { QR: qr },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );

    return respuesta;
  }

  ValidarCodigoCambioPassword(codigo): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ValidarCodigoCambioPassword',
      { Codigo: codigo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
        }),
      }
    );

    return respuesta;
  }

  getDocumentosPendientesDePagoFamiliasVinculadasAMi(
    idusuario,
    fecha_desde,
    fecha_hasta
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getDocumentosPendientesDePagoFamiliasVinculadasAMi?IdUsuario=' +
      idusuario +
      '&Fecha_Desde=' +
      fecha_desde +
      '&Fecha_Hasta=' +
      fecha_hasta,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getComprobantesFiscalesFamiliasVinculadasAMi(
    idusuario,
    fecha_desde,
    fecha_hasta
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getComprobantesFiscalesFamiliasVinculadasAMi?IdUsuario=' +
      idusuario +
      '&Fecha_Desde=' +
      fecha_desde +
      '&Fecha_Hasta=' +
      fecha_hasta,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getMensualidadMisEstudiantes(idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getMensualidadMisEstudiantes?IdUsuario=' + idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getMensualidadMisEstudiantesPagos(idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getMensualidadMisEstudiantesPagos?IdUsuario=' +
      idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getTarjetas(idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getTarjetas?IdUsuario=' + idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EliminarTarjeta(Tarjeta): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EliminarTarjeta',
      { Tarjeta },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCuotaInicialMisEstudiantes(idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getCuotaInicialMisEstudiantes?IdUsuario=' + idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getLibrosUtilesServicios(secciones): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getLibrosUtilesServicios?Secciones=' + secciones,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getAnticipos(
    idusuario,
    fecha_inicio,
    fecha_corte,
    aplicados = '0'
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getAnticipos?IdUsuario=' +
      idusuario +
      '&FechaInicio=' +
      fecha_inicio +
      '&FechaCorte=' +
      fecha_corte +
      '&Aplicados=' +
      aplicados,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getEstadosCuenta(idusuario, fecha_inicial, fecha_final): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getEstadosCuenta?IdUsuario=' +
      idusuario +
      '&FechaInicial=' +
      fecha_inicial +
      '&FechaFinal=' +
      fecha_final,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getEstadosCuentaEstudiante(
    idestudiante,
    fecha_inicial,
    fecha_final
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getEstadosCuentaEstudiante?IdEstudiante=' +
      idestudiante +
      '&FechaInicial=' +
      fecha_inicial +
      '&FechaFinal=' +
      fecha_final,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCompraUtiles(idusuario, fecha_inicial, fecha_final): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getCompraUtiles?IdUsuario=' +
      idusuario +
      '&FechaDesde=' +
      fecha_inicial +
      '&FechaHasta=' +
      fecha_final,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFavoritos(userid): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFavoritos?IdUsuario=' + userid,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCantComunicadosNoLeidos(userid, secciones): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getCantComunicadosNoLeidos?IdUsuario=' +
      userid +
      '&Secciones=' +
      secciones,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EnviarCorreo(Titulo, Cuerpo, Receptor): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/EviarPorCorreo',
      { Titulo, Cuerpo, Receptor },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCalificacionesEstudiante(idestudiante): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getCalificacionesEstudiante?IdEstudiante=' +
      idestudiante,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getReporteProgresoEstudiante(idestudiante): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getReporteProgresoEstudiante?IdEstudiante=' +
      idestudiante,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getEstudiantesInscritos(): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getEstudiantesInscritos',
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  BloquearDesbloquearNota(id_estudiante): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/BloquearDesbloquearNota', {IdEstudiante: id_estudiante},
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getConfiguraciones(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getConfiguraciones', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  ActualizarConfiguraciones(Configuraciones): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ActualizarConfiguraciones',
      { Configuraciones },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  AsociarUsuariosCursos(user, secciones, tipo): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/AsociarUsuariosCursos',
      { IdUsuario: user, Secciones: secciones, Tipo: tipo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFacturasFamilia(cods: string): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getFacturasFamilia?CodigosFamilias=' + cods,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getFacturasFamilia2(
    IdUsuario: string,
    FechaInicio,
    FechaFinal
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getFacturasFamilia2?IdUsuario=' +
      IdUsuario +
      '&FechaInicio=' +
      FechaInicio +
      '&FechaFinal=' +
      FechaFinal,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  setup_completion_with_card_number(card): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/setup_completion_with_card_number',
      { Card: card },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  enroll_with_pending_authentication(card): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/enroll_with_pending_authentication',
      { Card: card },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  RegistrarTarjeta(card): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/RegistrarTarjeta',
      { Card: card },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  RealizarPagoFacturasYAnticipos(datos): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/RealizarPagoFacturasYAnticipos',
      datos,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  EnviarArchivoPorCorreo(
    archivo: File,
    nombre,
    correo,
    descripcion
  ): Observable<any> {
    let form = new FormData();

    form.append('Archivo', archivo);
    form.append('Nombre', nombre);
    form.append('Correo', correo);
    form.append('Descripcion', descripcion);

    let respuesta = this.http.post(
      this.APILinkPWA + '/EnviarArchivoPorCorreo',
      form,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getNohup(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getNohup', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getLogEventos(fecha1, fecha2): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getLogEventos?Fecha1=' + fecha1 + '&Fecha2=' + fecha2,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getLogActividadUsuario(usuario, fecha1, fecha2): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getLogActividadUsuario?Usuario=' +
      usuario +
      '&Fecha1=' +
      fecha1 +
      '&Fecha2=' +
      fecha2,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getLogsDetallePagos(fecha1, fecha2): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getLogsDetallePagos?Fecha1=' +
      fecha1 +
      '&Fecha2=' +
      fecha2,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getLogsDetallePagosPorFamilia(codigo_familia): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getLogsDetallePagosPorFamilia?CodigoFamilia=' +
      codigo_familia,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getLogsDetalleTarjetas(fecha1, fecha2, usuario: any = 0): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getLogsDetalleTarjetas?Fecha1=' +
      fecha1 +
      '&Fecha2=' +
      fecha2 + '&IdUsuario=' + usuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getDatosActividadUsuarioFecha(
    usuario,
    fecha1,
    fecha2,
    hora
  ): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getDatosActividadUsuarioFecha?Usuario=' +
      usuario +
      '&Fecha1=' +
      fecha1 +
      '&Fecha2=' +
      fecha2 +
      '&Hora=' +
      hora,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  ReenviarCorreoDocumentosPagos(id_flujo): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/ReenviarCorreoDocumentosPagos',
      { IdFlujo: id_flujo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  MarcarComoPagoLosDocumentos(id_flujo, id_cobro, fecha, comentario =""): Observable<any> {
    let respuesta = this.http.post(
      this.APILinkPWA + '/MarcarComoPagoLosDocumentos',
      { IdFlujo: id_flujo, IdCobro: id_cobro, Fecha: fecha, Comentario: comentario },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  DesmarcarDocumentos(id_flujo, id_cobro, comentario = "", tipo): Observable<any> {

    let respuesta = this.http.post(this.APILinkPWA + "/DesmarcarDocumentos",
      { IdFlujo: id_flujo, IdCobro: id_cobro, Comentario: comentario, Tipo: tipo },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getDocumentosCobro(datos): Observable<any> {

    let respuesta = this.http.post(this.APILinkPWA + "/getDocumentosCobro",
      { Datos: datos },
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getIndicadoresLogrosProfesoresAsignaturasSecciones(id_anio, id_coordinador, id_profesor): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getIndicadoresLogrosProfesoresAsignaturasSecciones?IdAnio=' + id_anio + '&IdCoordinador=' + id_coordinador + '&IdProfesor=' + id_profesor,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getIndicadoresLogrosProfesores(idanio, id_coordinador): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getIndicadoresLogrosProfesores?IdAnio=' +
      idanio +
      '&IdCoordinador=' +
      id_coordinador,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  // CambiarContraseña(id: number, usuario: string, password: string, token: string) {
  //   let data = new HttpParams().set("NombreUsuario", usuario).set("Contraseña", password)

  //   return this.http.put(this.APILink + "/usuarios/" + id, data,
  //     {
  //       headers: new HttpHeaders({
  //         "Content-Type": 'application/x-www-form-urlencoded',
  //         "Authorization": token
  //       })
  //     })
  // }

  getEstudiantes(idfamilia: number) {
    return this.http.get(this.APILink + '/estudiantes/familias/' + idfamilia, {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('Token'),
      }),
    });
  }


  getIndicadoresLogroSeccionesEstado(idanio, idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getIndicadoresLogroSeccionesEstado?IdAnio=' +
      idanio +
      '&IdUsuario=' +
      idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getReportesProgresoSeccionesEstado(idanio, idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getReportesProgresoSeccionesEstado?IdAnio=' +
      idanio +
      '&IdUsuario=' +
      idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getReportesProgresoSeccionEstudiantes(id_seccion, idusuario): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getReportesProgresoSeccionEstudiantes?IdSeccion=' +
      id_seccion +
      '&IdUsuario=' +
      idusuario,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getReportesProgresoEstudiantes(id_inscripciones): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getReportesProgresoEstudiantes?IdInscripciones=' + id_inscripciones,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

  getCursosIndicadoresLogros(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + "/getCursosIndicadoresLogros",
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getIndicadoresLogrosSeccionesUsuario(id_usuario, id_anio): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogrosSeccionesUsuario?IdUsuario=" + id_usuario + "&IdAnio=" + id_anio,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getAsignaturasIndicadoresLogros(id_curso): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getAsignaturasIndicadoresLogros?IdCurso=0," + id_curso,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getTodasAsignaturasIndicadoresLogros(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + "/getTodasAsignaturasIndicadoresLogros",
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getAreasIndicadoresLogros(id_anio): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + "/getAreasIndicadoresLogros?IdAnio=" + id_anio,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getIndicadoresLogros(id_anio, id_cursos, id_asignaturas, id_areas): Observable<any> {

    let respuesta = this.http.get(this.APILinkPWA + "/getIndicadoresLogros?IdAnio=" + id_anio + "&IdCursos=0," + id_cursos + "&IdAsignatura=0," + id_asignaturas + "&IdAreas=0," + id_areas,
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getInscripcionesDisponibles(cods: string, anio_actual): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA +
      '/getInscripcionesDisponibles?CodigoFamilia=' +
      cods +
      '&EsAnioActual=' +
      anio_actual,
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );
    return respuesta;
  }

  AplicarIndicadoresEstudiantes(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + "/AplicarIndicadoresEstudiantes", { Datos: datos },
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  EliminarAplicacionesIndicadores(datos): Observable<any> {
    let respuesta = this.http.post(this.APILinkPWA + "/EliminarAplicacionesIndicadores", { Datos: datos },
      {
        headers: new HttpHeaders({
          "AppId": this.TokenApp, Token: atob(localStorage.getItem(btoa("Token")))
        })
      })


    return respuesta
  }

  getTodosLosHijosDeFamilias(fams: string): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getTodosLosHijosDeFamilias?Familias='+fams, {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  getVersionAPI(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getVersionAPI', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }

  VerificarVersion(version_actual): Observable<any> {
    return this.http.get(this.APILinkPWA + '/VerificarVersion?VersionActual='+version_actual,  {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
      }),
    });
  }

  getFechaInicioAnio(): Observable<any> {
    let respuesta = this.http.get(this.APILinkPWA + '/getFechaInicioAnio', {
      headers: new HttpHeaders({
        AppId: this.TokenApp,
        Token: atob(localStorage.getItem(btoa('Token'))),
      }),
    });

    return respuesta;
  }


  getTareasAutomaticas(): Observable<any> {
    let respuesta = this.http.get(
      this.APILinkPWA + '/getTareasAutomaticas',
      {
        headers: new HttpHeaders({
          AppId: this.TokenApp,
          Token: atob(localStorage.getItem(btoa('Token'))),
        }),
      }
    );

    return respuesta;
  }

}

